<template>
    <div class="number-answer">
        <div class="test-question-answer-container">

            <div class="control test-question-answer-options">
                <div
                    class="test-question-answer-option-container"
                    :class="{
                        'is-answer-right': !isInterview && answer.is_right,
                        'is-answer-wrong': !isInterview && answer.is_wrong,
                    }"
                >
                    <div class="value">{{ answer.text }}</div>
                    <statistics-answer-points
                        v-if="!isInterview"
                        :points="answer.points"
                        :as-checkbox="!isHasPoints"
                    />
                </div>
            </div>
        </div>
        <div class="mt-1 mb-1" v-if="!isRight && options.length > 1 && rightAnswers.length > 0 && !isInterview">{{ trans.statistics.right_answer }}</div>
        <div class="test-question-answer-container" v-if="!isRight && options.length > 1 && rightAnswers.length > 0 && !isInterview">
            <div class="control test-question-answer-options">
                <div
                    class="test-question-answer-option-container"
                    v-for="(option, index) in rightAnswers"
                    :key="index"
                >
                    <div class="value">{{ option.text }}</div>
                    <statistics-answer-points
                        v-if="!isInterview"
                        :points="option.points"
                        :as-checkbox="!isHasPoints"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import StatisticsAnswerPoints from "../StatisticsAnswerPoints";

export default {
    name: "StatisticsNumberInputAnswer",
    components: {StatisticsAnswerPoints},
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        isRight: false,
        isInterview: false,
        isHasPoints: false,
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
        ]),
        rightAnswers() {
            return this.options.filter(item => item.is_set_as_right);
        },
        answer() {
            return this.options.find(item => item.answered);
        },
    },
}
</script>